var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _vm.$checkPermission("AGENCYPARAMETERS")
                    ? _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "light-blue lighten-2",
                          icon: "fa-plus",
                          tooltip: _vm.$t("global.crud.button.add")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.create()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "12", md: "6", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.datatable.search"),
                                  "append-icon": "fas fa-search",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.filter.allFields,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "allFields", $$v)
                                  },
                                  expression: "filter.allFields"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", md: "6", cols: "12" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.agenciesFilterItems,
                                  loading: _vm.agenciesFilter.isLoading,
                                  "search-input": _vm.agenciesFilter.search,
                                  "hide-no-data": "",
                                  "no-data-text": _vm.$t(
                                    "global.autocomplete.noDataFound"
                                  ),
                                  "item-text": "description",
                                  "item-value": "code",
                                  label: _vm.$t("agencyParameters.agency"),
                                  placeholder: _vm.$t(
                                    "global.autocomplete.starTypingToSearch"
                                  ),
                                  clearable: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  "update:search-input": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.agenciesFilter.isEdit = true
                                  },
                                  change: function($event) {
                                    _vm.agenciesFilter.isEdit = false
                                  }
                                },
                                model: {
                                  value: _vm.filter.agencyCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "agencyCode", $$v)
                                  },
                                  expression: "filter.agencyCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: {
                      url: "/agencyParameters",
                      filter: this.filter,
                      filterExport: _vm.filterExport
                    }
                  }),
                  _c("ImportExcel", {
                    attrs: { url: "/agencyParameters" },
                    on: { done: _vm.search }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c(
                            "tr",
                            { key: item.code + item.agencyCode },
                            [
                              _c(
                                "td",
                                [
                                  _vm.$checkPermission("AGENCYPARAMETERS")
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "orange",
                                          icon: "fa-pen",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.edit"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.edit(
                                              item.code,
                                              item.agencyCode
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  (item.deletionDate === undefined ||
                                    item.deletionDate === null) &&
                                  _vm.$checkPermission("AGENCYPARAMETERS")
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "red",
                                          icon: "fa-trash",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.delete"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.suspend(
                                              item.code,
                                              item.agencyCode
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.code))]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on }) {
                                              return [
                                                _c("span", _vm._g({}, on), [
                                                  _vm._v(
                                                    _vm._s(item.agency.code)
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.agency.name))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.value))])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ invalid, validated, passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        !_vm.editMode
                                          ? _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "agencyParameters.code"
                                                ),
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            items:
                                                              _vm.agencyParametersTypesItems,
                                                            loading:
                                                              _vm
                                                                .agencyParametersTypes
                                                                .isLoading,
                                                            "search-input":
                                                              _vm
                                                                .agencyParametersTypes
                                                                .search,
                                                            "hide-no-data": "",
                                                            "no-data-text": _vm.$t(
                                                              "global.autocomplete.noDataFound"
                                                            ),
                                                            "item-text":
                                                              "description",
                                                            "item-value":
                                                              "code",
                                                            label: _vm.$t(
                                                              "agencyParameters.code"
                                                            ),
                                                            placeholder: _vm.$t(
                                                              "global.autocomplete.starTypingToSearch"
                                                            ),
                                                            "error-messages": errors,
                                                            clearable: ""
                                                          },
                                                          on: {
                                                            "update:searchInput": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agencyParametersTypes,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            "update:search-input": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agencyParametersTypes,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            focus: function(
                                                              $event
                                                            ) {
                                                              _vm.agencyParametersTypes.isEdit = true
                                                            },
                                                            change: function(
                                                              $event
                                                            ) {
                                                              _vm.agencyParametersTypes.isEdit = false
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item.code,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "code",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.code"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "agencyParameters.code"
                                                ),
                                                disabled: ""
                                              },
                                              model: {
                                                value: _vm.item.code,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "code",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.code"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        !_vm.editMode
                                          ? _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "agencyParameters.agency"
                                                ),
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            items:
                                                              _vm.agenciesItems,
                                                            loading:
                                                              _vm.agencies
                                                                .isLoading,
                                                            "search-input":
                                                              _vm.agencies
                                                                .search,
                                                            "hide-no-data": "",
                                                            "no-data-text": _vm.$t(
                                                              "global.autocomplete.noDataFound"
                                                            ),
                                                            "item-text":
                                                              "description",
                                                            "item-value":
                                                              "code",
                                                            label: _vm.$t(
                                                              "agencyParameters.agency"
                                                            ),
                                                            placeholder: _vm.$t(
                                                              "global.autocomplete.starTypingToSearch"
                                                            ),
                                                            "error-messages": errors,
                                                            clearable: ""
                                                          },
                                                          on: {
                                                            "update:searchInput": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agencies,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            "update:search-input": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agencies,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            focus: function(
                                                              $event
                                                            ) {
                                                              _vm.agencies.isEdit = true
                                                            },
                                                            change: function(
                                                              $event
                                                            ) {
                                                              _vm.agencies.isEdit = false
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .agencyCode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "agencyCode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.agencyCode"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "agencyParameters.agency"
                                                ),
                                                disabled: ""
                                              },
                                              model: {
                                                value: _vm.item.agencyString,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "agencyString",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.agencyString"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "agencyParameters.value"
                                            ),
                                            rules: "required|max:100"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "agencyParameters.value"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "100"
                                                      },
                                                      model: {
                                                        value: _vm.item.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.value"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }